/* eslint-disable @next/next/no-img-element */
import http from "utilities/http";
import ArticleComponent from "components/cong-dong/articleComponent";
import { isEmpty } from "lodash";
import {getCookie} from "framework/libs/cookie";
import {TOKEN_CONGDONG} from "framework/store/constants";
import { useEffect, useState } from "react";
import SeeMore from "components/seeMore";
import { Loader } from "../../loader";

export default function Index({ profession }){
    const perPage = 4;
    const [reviewsPage, setReviewsPage] = useState([perPage, 0]);
    const [reviews, setReviews] = useState([]);
    const [currentPage,setCurrentPage]= useState(1);
    const [loading,setLoading]= useState(false);
    useEffect(()=>{
        if (currentPage > 1){
            const fetchReview = async () => {
                setLoading(true);
                const token = !isEmpty(getCookie(TOKEN_CONGDONG)) ? 'Bearer ' + getCookie(TOKEN_CONGDONG) : 'default';
                let url = `community/professional/${profession.id}/reviews?page=${currentPage}&per_page=${perPage}`;
                const response = await http(url, {}, { token: token }, 'v2');
                setReviews(reviews?.concat(response?.data || []));
                setReviewsPage([perPage, response.meta?.pagination?.total || 0]);
                setLoading(false);
            };
            fetchReview();
        }
    },[currentPage]);

    return (
        <>
            {
                !isEmpty(reviews) && <div className="list-wrap reviews">
                    <ul>
                        {reviews.map((item, index) => {
                            return (
                                <ArticleComponent key={index} item={item} index={index} slug={'review'}></ArticleComponent>
                            );
                        })}
                    </ul>
                </div>
            }
            <Loader loading={loading}/>
            <SeeMore page={reviewsPage} currentPage={currentPage} setCurrentPage={setCurrentPage}/>
            {
                isEmpty(reviews) && <div className="expert__wrap-content expert-voucher">
                    <div className="voucher-none">
                        <div className="thumb"><img src="/images/icon-no-data.svg" alt="" /></div>
                        <p className="text">Chưa có bài đánh giá nào</p>
                    </div>
                </div>
            }
        </>);
}